import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import CallIcon from '@material-ui/icons/Call';
import LoopIcon from '@material-ui/icons/Loop';
import {useSelector} from "react-redux";
import Utils from "../../../helpers/Utils";
import ScrollText from "../../custom/ScrollText";
import LastCallTime from "./LastCallTime";
import {GlobalDialerV2Styles} from "./GlobalDialerV2Styles";

const useStyles = makeStyles((theme) => ({
    callWrapper: {
        color: '#fff',
        "& .headerSection": {
            display: 'flex !important',
            justifyContent: 'space-between !important',
            alignItems: 'center !important',
            padding: '12px !important',
            paddingLeft: '0px !important',
            paddingTop: '4px !important',
            borderBottom: '1px solid #e5e8ef !important',

            "& .headerSectionLeft": {
                display: 'flex !important',
                alignItems: 'center !important',
                gap: '8px !important',

                '& .MuiSvgIcon-root': {
                    color: '#fff !important'
                }
            },

            "& .headerSectionRight": {
                display: "flex",
                flexDirection: "column",
                alignItems: "end",

                "& .callStatus": {
                    borderRadius: "10px",
                    textAlign: "center",
                    fontSize: "12px",
                    width: "fit-content",
                    padding: "0px 10px",
                    marginBottom: "4px",

                    "&.calling": {
                        backgroundColor: "#f8d300ff",
                        color: "#000"
                    },

                    "&.inCall": {
                        backgroundColor: "#ff0055",
                        color: "#fff"
                    }
                }
            }
        },
        '& .footerSection': {
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginTop: 20,

            '& .callBackButton': {
                borderColor: '#33f28b !important',
                color: '#fff !important',

                '& svg': {
                    color: '#fff !important',
                },

                '&:hover, &:focus': {
                    borderColor: '#33f28b !important',
                    color: '#fff !important',
                }
            }
        }
    },
}));

const ColdTransfer = ({ initiateCalling }) => {
    const {callEnvironment, lastCallTime, lastCaller} = useSelector((state)=>(state.globalDialerV2));
    const classes = useStyles();
    const globalClasses = GlobalDialerV2Styles();

    const renderCallerInfo = () => {
        const view = [];

        if (lastCaller?.callerName && !Utils.isNumeric(lastCaller?.callerName)){
            view.push(
                <ScrollText width={120}>
                    <h6 style={{ margin: '0px 4px 4px', fontSize: '15px' }}>{lastCaller?.callerName}</h6>
                </ScrollText>
            );
        }else {
            view.push(<h6 style={{ margin: 0, fontSize: '15px' }}>Unknown</h6>);
        }

        if (lastCaller?.number){
            view.push(<h6 style={{ margin: 0, fontSize: '14px' }}>{Utils.formatNumber(lastCaller?.number)}</h6>);
        }

        return (
            <div>
                {view}
            </div>
        );
    };

    const renderCallStatus = () => {
        return <div className="callStatus inCall">Call Transferred</div>;
    };

    return (
        <div className={globalClasses.globalDialerV2Wrapper}>
            <div className={classes.callWrapper}>
            <div  className='headerSection'>
                <div className='headerSectionLeft'>
                    <CallIcon />

                    {renderCallerInfo()}
                </div>

                <div className="headerSectionRight">
                    {renderCallStatus()}
                    <LastCallTime
                        callTime={lastCallTime}
                    />
                </div>
            </div>

            <div className='footerSection'>
                <Button
                    variant='outlined'
                    className={'callBackButton'}
                    disableElevation
                    fullWidth
                    style={{
                        fontWeight: "600",
                        textTransform: "capitalize"
                    }}
                    onClick={() => initiateCalling(null, callEnvironment.fromNumber, null)}
                    startIcon={<LoopIcon/>}
                >
                    Call Back
                </Button>
            </div>
        </div>
        </div>
    );
};

export default ColdTransfer;